import React, { Fragment, useEffect, useState } from "react";
import { set_categories } from "../../../redux/actions/CategoriesAction";
import { set_service_details } from "../../../redux/actions/ServicesAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import { type } from "../../../components/Dropzone/type";
import { set_loading } from "../../../redux/actions/LayoutAction";
import ClipLoader from "react-spinners/ClipLoader";
import { Field, Form, Formik } from "formik";
import Header from "../subheader/Header";
import * as Yup from "yup";
import DropzoneElement from "../../../components/Dropzone/DropzoneElement";
import { FileUploadPromise } from "../../../utils/aws_s3/aws_s3";
import "./service.scss";
import { useLocation, useParams, useHistory } from "react-router-dom";
import ImagesGrid from "../../../components/Dropzone/ImagesGrid";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import RSelect from "react-select";
import { getClass, IsQuillEmpty, deleteS3Image } from "../../../utils/utils";
import Resizer from "react-image-file-resizer";

const serviceSchema = Yup.object().shape({
  name_ar: Yup.string(),
  description_ar: Yup.string(),
  name_en: Yup.string().required("Required"),
  description_en: Yup.string().required("Required").nullable("Required"),
  price: Yup.number().min(0, "Negative not allowed").required("Required"),
  category_id: Yup.array().min(1, "Required"),
  discounted_price: Yup.number().min(0, "Negative not allowed"),
  unit_time: Yup.number().min(0, "Negative not allowed"),
  benefits_en: Yup.string().required("Required").nullable("Required"),
  benefits_ar: Yup.string(),
  features_en: Yup.string().required("Required").nullable("Required"),
  featured_image: Yup.string()
    .required("Feature image required")
    .nullable("Feature image required"),
  images: Yup.array()
    .of(Yup.string().required())
    .min(1, "Upload at least one image"),
  features_ar: Yup.string(),
  how_to_use_en: Yup.string().required("Required").nullable("Required"),
  how_to_use_ar: Yup.string(),
});

const Service = (props) => {
  const param = useParams();
  const location = useLocation();
  const history = useHistory();
  const [serviceValues, setServiceValues] = useState({});
  const [categoryOption, setCategoryOption] = useState([]);
  const [uploadingSingleImage, setUploadingSingleImage] = useState(false);
  const [data, setData] = useState(false);
  const [isEditClick, setisEditClick] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadingImages, setUploadingImages] = useState(false);

  var combine = [];
  var relatedservice = [];
  const [selectedProduct, setSelectedProduct] = useState();
  const [selectedService, setSelectedService] = useState();
  const [selectedTool, setSelectedTool] = useState();
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [relatedTools, setRelatedTools] = useState([]);
  const [relatedServices, setRelatedServices] = useState([]);
  var extraService = [];
  var extraProduct = [];
  var extraTools = [];
  const [deletedImagesUrl, setDeletedImagesUrl] = useState([]);

  const resizeFileForDesktop = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        250,
        250,
        "png",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "blob"
      );
    });
  const resizeFileForMob = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        100,
        100,
        "png",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "blob"
      );
    });

  const handleFilesChange = (files, setFieldValue, images) => {
    let fileUploadPromises = [];
    setUploadingImages(true);

    files.forEach((file) => {
      fileUploadPromises.push(FileUploadPromise(file));
    });

    Promise.all(fileUploadPromises)
      .then((response) => {
        setUploadingImages(false);
        setFieldValue("images", [
          ...images,
          ...response.map((image) => image.location),
        ]);
      })
      .catch((err) => {
        setUploadingImages(false);
        message = "File upload error";
        showError();
      });
  };

  const handleSingleFilesChange = async (files, setFieldValue) => {
    let fileUploadPromises = [];
    setUploadingSingleImage(true);
    const resizeImageDesktop = await resizeFileForDesktop(files[0]);
    const resizeImageMob = await resizeFileForMob(files[0]);

    files.push(resizeImageMob);
    files.push(resizeImageDesktop);

    files.forEach((file) => {
      fileUploadPromises.push(FileUploadPromise(file));
    });

    Promise.all(fileUploadPromises)
      .then((response) => {
        setUploadingSingleImage(false);
        setFieldValue("featured_image", response[0].location);
        setFieldValue("featured_image_resized", [
          response[1].location,
          response[2].location,
        ]);
      })
      .catch((err) => {
        setUploadingSingleImage(false);
        message = "File upload error";
        showError();
      });
  };

  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const getRelatedData = () => {
    if (location.state.name === "create" || location.state.name === "edit") {
      apiJson.services.getRelatedServices().then((res) => {
        if (res.success) {
          res.data.map((item) => {
            extraService.push({ value: item.id, label: item.name_en });
            return item;
          });
          setRelatedServices(extraService);
        }
      });
      apiJson.products.getRelatedProducts().then((res) => {
        if (res.success) {
          res.data.map((item) => {
            extraProduct.push({ value: item.id, label: item.name_en });
            return item;
          });
          setRelatedProducts(extraProduct);
        }
      });
      apiJson.products.getRelatedTools().then((res) => {
        if (res.success) {
          res.data.map((item) => {
            extraTools.push({ value: item.id, label: item.name_en });
            return item;
          });
          setRelatedTools(extraTools);
        }
      });
    }
  };
  useEffect(() => {
    document.title = "Service";
    getRelatedData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setData(false);
    if (location.state.name === "edit" || location.state.name === "view") {
      if (location.state.name === "edit") {
        setisEditClick(true);
        apiJson.categories.getCategorieForProductServices().then((response) => {
          if (response.success) {
            props.set_categories({ categories: response.data });

            setCategoryOption(
              response.data.map((category) => {
                return {
                  value: category.id,
                  label: category.title_en,
                };
              })
            );
          } else if (!response.status) {
            // eslint-disable-next-line
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          } else {
            if (response.status >= 400 && response.status < 500) {
              message = response.message
                ? response.message
                : response.errors
                ? response.errors
                : "something went wrong";
              showError();
            } else {
              message = response.message
                ? response.message !== ""
                  ? response.message
                  : "something went wrong"
                : "something went wrong";
              showError();
            }
          }
        });
      } else {
        setisEditClick(false);
      }
      let extraProductSD = [];
      let extraServiceSD = [];
      let extraToolsSD = [];

      apiJson.services.getServiceDetail(parseInt(param.id)).then((response) => {
        if (response.success) {
          props.set_service_details({ serviceDetails: response.data });
          setServiceValues({
            ...response.data,
            category_id: response.data.categories?.map((category) => {
              return {
                value: category.id,
                label: category.title_en,
              };
            }),
          });
          getRelatedData();
          response.data.related_services?.map((item) => {
            extraServiceSD.push({ value: item.id, label: item.name_en });
            return item;
          });
          setSelectedService(extraServiceSD);
          response.data.related_products?.map((item) => {
            extraProductSD.push({ value: item.id, label: item.name_en });
            return item;
          });
          setSelectedProduct(extraProductSD);
          response.data.related_tools?.map((item) => {
            extraToolsSD.push({ value: item.id, label: item.name_en });
            return item;
          });
          setSelectedTool(extraToolsSD);
          setData(true);
        } else if (!response.status) {
          setData(false);
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          setData(false);
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
              ? response.errors
              : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
    } else {
      setisEditClick(true);
      setServiceValues({
        name_en: "",
        description_en: "",
        name_ar: "",
        description_ar: "",
        price: "",
        discounted_price: "",
        unit_time: "",
        category_id: [],
        category_title_en: "",
        benefits_en: "",
        benefits_ar: "",
        features_en: "",
        features_ar: "",
        how_to_use_en: "",
        how_to_use_ar: "",
        featured_image: "",
        featured_image_resized: [],
        images: [],
      });
      apiJson.categories.getCategorieForProductServices().then((response) => {
        if (response.success) {
          props.set_categories({ categories: response.data });
          setCategoryOption(
            response.data.map((category) => {
              return {
                value: category.id,
                label: category.title_en,
              };
            })
          );
        } else if (!response.status) {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
              ? response.errors
              : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
      setData(true);
    }

    setDeletedImagesUrl([]);
  }, [location.state.name]);

  const heading = isEditClick ? "Create/Edit Service" : "View service";

  const mergeArrays = () => {
    selectedProduct?.map((item) => {
      combine.push({ related_product_id: parseInt(item.value) });
      return item;
    });
    selectedTool?.map((item) => {
      combine.push({ related_product_id: parseInt(item.value) });
      return item;
    });
    return combine;
  };

  const convertToServiceList = () => {
    selectedService?.map((item) => {
      relatedservice.push({ related_service_id: parseInt(item.value) });
      return item;
    });
    return relatedservice;
  };

  const Create = (value) => {
    if (value?.images?.length > 0) {
      deleteS3Image(deletedImagesUrl);
      var service_related_products = mergeArrays();
      var service_related_services = convertToServiceList();
      setLoading(true);
      apiJson.services
        .createService({
          service: {
            name_en: value.name_en,
            description_en: value.description_en,
            name_ar:
              value.name_ar?.length > 1 && value.name_ar !== "<p><br></p>"
                ? value.name_ar
                : value.name_en,
            description_ar:
              value.description_ar?.length > 1 &&
              value.description_ar !== "<p><br></p>"
                ? value.description_ar
                : value.description_en,
            price: parseFloat(value.price),
            discounted_price:
              value.discounted_price && parseFloat(value.discounted_price) > 0
                ? parseFloat(value.discounted_price)
                : parseFloat(value.price),
            unit_time: parseFloat(value.unit_time),
            service_categories_attributes: value.category_id.map((cat) => {
              return { category_id: cat.value };
            }),
            images: value.images,
            featured_image: value.featured_image,
            featured_image_resized: value.featured_image_resized,
            benefits_en: value.benefits_en,
            benefits_ar:
              value.benefits_ar?.length > 1 &&
              value.benefits_ar !== "<p><br></p>"
                ? value.benefits_ar
                : value.benefits_en,
            features_en: value.features_en,
            features_ar:
              value.features_ar?.length > 1 &&
              value.features_ar !== "<p><br></p>"
                ? value.features_ar
                : value.features_en,
            how_to_use_en: value.how_to_use_en,
            how_to_use_ar:
              value.how_to_use_ar?.length > 1 &&
              value.how_to_use_ar !== "<p><br></p>"
                ? value.how_to_use_ar
                : value.how_to_use_en,
            service_related_products_attributes: service_related_products,
            service_related_services_attributes: service_related_services,
          },
        })
        .then((response) => {
          if (response.success) {
            setLoading(false);
            history.push({
              pathname: `/vendor/service/${response.data.id}`,
              state: { name: "view", id: response.data.id },
            });
          } else if (!response.status) {
            setLoading(false);
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          } else {
            setLoading(false);
            if (response.status >= 400 && response.status < 500) {
              message = response.message
                ? response.message
                : response.errors
                ? response.errors
                : "something went wrong";
              showError();
            } else {
              message = response.message
                ? response.message !== ""
                  ? response.message
                  : "something went wrong"
                : "something went wrong";
              showError();
            }
          }
        });
    } else {
      message = "Please upload atleast one image";
      showError();
    }
  };

  const Update = (value) => {
    var service_related_products = mergeArrays();
    var service_related_services = convertToServiceList();

    if (value?.images?.length > 0) {
      deleteS3Image(deletedImagesUrl);
      setLoading(true);
      apiJson.services
        .updateService(location.state.id, {
          service: {
            id: location.state.id,
            name_en: value.name_en,
            description_en: value.description_en,
            name_ar:
              value.name_ar?.length > 1 && value.name_ar !== "<p><br></p>"
                ? value.name_ar
                : value.name_en,
            description_ar:
              value.description_ar?.length > 1 &&
              value.description_ar !== "<p><br></p>"
                ? value.description_ar
                : value.description_en,
            price: parseFloat(value.price),
            discounted_price:
              value.discounted_price && parseFloat(value.discounted_price) > 0
                ? parseFloat(value.discounted_price)
                : parseFloat(value.price),
            status: serviceValues.status,
            unit_time: parseFloat(value.unit_time),
            service_categories_attributes: value.category_id.map((cat) => {
              return { category_id: cat.value };
            }),
            images: value.images,
            featured_image: value.featured_image,
            featured_image_resized: value.featured_image_resized,
            benefits_en: value.benefits_en,
            benefits_ar:
              value.benefits_ar?.length > 1 &&
              value.benefits_ar !== "<p><br></p>"
                ? value.benefits_ar
                : value.benefits_en,
            features_en: value.features_en,
            features_ar:
              value.features_ar?.length > 1 &&
              value.features_ar !== "<p><br></p>"
                ? value.features_ar
                : value.features_en,
            how_to_use_en: value.how_to_use_en,
            how_to_use_ar:
              value.how_to_use_ar?.length > 1 &&
              value.how_to_use_ar !== "<p><br></p>"
                ? value.how_to_use_ar
                : value.how_to_use_en,
            service_related_products_attributes: service_related_products,
            service_related_services_attributes: service_related_services,
          },
        })
        .then((response) => {
          if (response.success) {
            setLoading(false);
            history.push({
              pathname: `/vendor/service/${parseInt(param.id)}`,
              state: { name: "view", id: parseInt(param.id) },
            });
          } else if (!response.status) {
            setLoading(false);
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          } else {
            setLoading(false);
            if (response.status >= 400 && response.status < 500) {
              message = response.message
                ? response.message
                : response.errors
                ? response.errors
                : "something went wrong";
              showError();
            } else {
              message = response.message
                ? response.message !== ""
                  ? response.message
                  : "something went wrong"
                : "something went wrong";
              showError();
            }
          }
        });
    } else {
      message = "Please upload atleast one image";
      showError();
    }
  };

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      <div className="vendor-page-right service-page-desktop">
        <Header heading={heading} search={false} filters={null} />
        <div className="right-content service-page-content-container">
          {data && (
            <div className="form-container">
              <Formik
                initialValues={serviceValues}
                validationSchema={serviceSchema}
                enableReinitialize
                onSubmit={(values) => {
                  if (param.state && param.state === "edit") {
                    Update(values);
                  } else {
                    Create(values);
                  }
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  setFieldValue,
                  setFieldTouched,
                }) => (
                  <Form className="service-form mx-auto">
                    <fieldset disabled={!isEditClick}>
                      <div className="row mx-0">
                        <div className="english-col col-12">
                          <div className="row mx-0">
                            <div className="label col-2">Name</div>
                            <div className="col-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.name_en && errors.name_en
                                )}`}
                                name="name_en"
                                type="text"
                                placeholder="Enter name"
                              />
                              {touched.name_en && errors.name_en && (
                                <div className="english-error">
                                  {errors.name_en}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="arabic-col col-12">
                          <div className="row mx-0 justify-content-end  align-items-start">
                            <div className="col-8 input">
                              <Field
                                className="w-100"
                                name="name_ar"
                                type="text"
                                placeholder="أدخل الاسم"
                              />
                            </div>
                            <div className="label col-2">اسم</div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="english-col col-12">
                          <div className="row mx-0">
                            <div className="label col-2">Description</div>
                            <div className="col-8 input">
                              <Field
                                className="w-100"
                                name="description_en"
                                type="text"
                              >
                                {({ field }) => (
                                  <ReactQuill
                                    className={getClass(
                                      touched.description_en &&
                                        errors.description_en
                                    )}
                                    readOnly={!isEditClick}
                                    value={field.value ? field.value : ""}
                                    onChange={(value) =>
                                      setFieldValue(
                                        "description_en",
                                        IsQuillEmpty(value) ? "" : value
                                      )
                                    }
                                    onBlur={() =>
                                      setFieldTouched("description_en", true)
                                    }
                                  />
                                )}
                              </Field>
                              {touched.description_en &&
                                errors.description_en && (
                                  <div className="english-error">
                                    {errors.description_en}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="arabic-col col-12">
                          <div className="row mx-0 justify-content-end align-items-start">
                            <div className="col-8 input">
                              <Field
                                className="w-100"
                                name="description_ar"
                                type="text"
                                placeholder="أدخل الوصف"
                              >
                                {({ field }) => (
                                  <ReactQuill
                                    readOnly={!isEditClick}
                                    value={field.value ? field.value : ""}
                                    onChange={(value) =>
                                      setFieldValue(
                                        "description_ar",
                                        IsQuillEmpty(value) ? "" : value
                                      )
                                    }
                                  />
                                )}
                              </Field>
                            </div>
                            <div className="label col-2">وصف</div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="english-col col-12">
                          <div className="row mx-0">
                            <div className="label col-2">Category</div>
                            <div className="col-8 input">
                              <RSelect
                                isMulti
                                value={values.category_id}
                                onChange={(value) => {
                                  setFieldValue("category_id", value);
                                }}
                                onBlur={() =>
                                  setFieldTouched("category_id", true)
                                }
                                options={categoryOption}
                                className={`category-select w-100 ${getClass(
                                  touched.category_id && errors.category_id
                                )}`}
                                classNamePrefix="control"
                                isDisabled={!isEditClick}
                                placeholder="Select Category"
                              />

                              {touched.category_id && errors.category_id && (
                                <div className="english-error">
                                  {errors.category_id}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="english-col col-12">
                          <div className="row mx-0 align-items-start">
                            <div className="label col-2">Benefits</div>
                            <div className=" input col-8">
                              <Field
                                className="w-100"
                                name="benefits_en"
                                type="text"
                                component="textarea"
                              >
                                {({ field }) => (
                                  <ReactQuill
                                    className={getClass(
                                      touched.benefits_en && errors.benefits_en
                                    )}
                                    readOnly={!isEditClick}
                                    value={field.value ? field.value : ""}
                                    onChange={(value) =>
                                      setFieldValue(
                                        "benefits_en",
                                        IsQuillEmpty(value) ? "" : value
                                      )
                                    }
                                    onBlur={() =>
                                      setFieldTouched("benefits_en", true)
                                    }
                                  />
                                )}
                              </Field>
                              {touched.benefits_en && errors.benefits_en && (
                                <div className="english-error">
                                  {errors.benefits_en}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="arabic-col col-12">
                          <div className="row mx-0 justify-content-end align-items-start">
                            <div className="input col-8">
                              <Field
                                className="w-100"
                                name="benefits_ar"
                                type="text"
                                component="textarea"
                              >
                                {({ field }) => (
                                  <ReactQuill
                                    readOnly={!isEditClick}
                                    value={field.value ? field.value : ""}
                                    onChange={(value) =>
                                      setFieldValue(
                                        "benefits_ar",
                                        IsQuillEmpty(value) ? "" : value
                                      )
                                    }
                                  />
                                )}
                              </Field>
                            </div>
                            <div className="label col-2">فوائد</div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="english-col col-12">
                          <div className="row mx-0 align-items-start">
                            <div className="label col-2">Features</div>
                            <div className=" input col-8">
                              <Field
                                className="w-100"
                                name="features_en"
                                type="text"
                                onChange={handleChange}
                                value={values.features_en}
                                component="textarea"
                              >
                                {({ field }) => (
                                  <ReactQuill
                                    className={getClass(
                                      touched.features_en && errors.features_en
                                    )}
                                    readOnly={!isEditClick}
                                    value={field.value ? field.value : ""}
                                    onChange={(value) =>
                                      setFieldValue(
                                        "features_en",
                                        IsQuillEmpty(value) ? "" : value
                                      )
                                    }
                                    onBlur={() =>
                                      setFieldTouched("features_en", true)
                                    }
                                  />
                                )}
                              </Field>
                              {touched.features_en && errors.features_en && (
                                <div className="english-error">
                                  {errors.features_en}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="arabic-col col-12">
                          <div className="row mx-0 justify-content-end align-items-start">
                            <div className=" input col-8">
                              <Field
                                className="w-100"
                                name="features_ar"
                                type="text"
                                onChange={handleChange}
                                value={values.features_ar}
                                component="textarea"
                              >
                                {({ field }) => (
                                  <ReactQuill
                                    readOnly={!isEditClick}
                                    value={field.value ? field.value : ""}
                                    onChange={(value) =>
                                      setFieldValue(
                                        "features_ar",
                                        IsQuillEmpty(value) ? "" : value
                                      )
                                    }
                                  />
                                )}
                              </Field>
                            </div>
                            <div className="label col-2">سمات</div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="english-col col-12">
                          <div className="row mx-0 align-items-start">
                            <div className="label col-2">How to use</div>
                            <div className=" input col-8">
                              <Field
                                className="w-100"
                                name="how_to_use_en"
                                type="text"
                                onChange={handleChange}
                                value={values.how_to_use_en}
                                component="textarea"
                              >
                                {({ field }) => (
                                  <ReactQuill
                                    className={getClass(
                                      touched.how_to_use_en &&
                                        errors.how_to_use_en
                                    )}
                                    readOnly={!isEditClick}
                                    value={field.value ? field.value : ""}
                                    onChange={(value) =>
                                      setFieldValue(
                                        "how_to_use_en",
                                        IsQuillEmpty(value) ? "" : value
                                      )
                                    }
                                    onBlur={() =>
                                      setFieldTouched("how_to_use_en", true)
                                    }
                                  />
                                )}
                              </Field>
                              {touched.how_to_use_en &&
                                errors.how_to_use_en && (
                                  <div className="english-error">
                                    {errors.how_to_use_en}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="arabic-col col-12">
                          <div className="row mx-0 justify-content-end align-items-start">
                            <div className=" input col-8">
                              <Field
                                className="w-100"
                                name="how_to_use_ar"
                                type="text"
                                onChange={handleChange}
                                value={values.how_to_use_ar}
                                component="textarea"
                              >
                                {({ field }) => (
                                  <ReactQuill
                                    readOnly={!isEditClick}
                                    value={field.value ? field.value : ""}
                                    onChange={(value) =>
                                      setFieldValue(
                                        "how_to_use_ar",
                                        IsQuillEmpty(value) ? "" : value
                                      )
                                    }
                                  />
                                )}
                              </Field>
                            </div>
                            <div className="label col-2">كيف تستعمل</div>
                          </div>
                        </div>
                      </div>

                      <div className="row mx-0">
                        <div className="english-col col-6">
                          <div className="row mx-0 d-flex justify-content-start">
                            <div className="label price-label col-4">Price</div>
                            <div className="col-4 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.price && errors.price
                                )}`}
                                name="price"
                                min="0"
                                step="0.01"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                placeholder="0.00"
                              />
                              {touched.price && errors.price && (
                                <div className="english-error">
                                  {errors.price}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="english-col col-6">
                          <div className="row mx-0 d-flex justify-content-start">
                            <div className="label discount-label col-4">
                              Discount Price
                            </div>
                            <div className="col-4 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.discounted_price &&
                                    errors.discounted_price
                                )}`}
                                name="discounted_price"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                placeholder="0.00"
                                min="0"
                                step="0.01"
                              />
                              {touched.discounted_price &&
                                errors.discounted_price && (
                                  <div className="english-error">
                                    {errors.discounted_price}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mx-0">
                        <div className="select-related col-md-10 ">
                          <div className="row w-100">
                            <label className="label all-text col-2">
                              Related Products
                            </label>
                            <div className="col-9 selector">
                              <RSelect
                                isMulti
                                isDisabled={!isEditClick}
                                value={selectedProduct}
                                onChange={setSelectedProduct}
                                options={relatedProducts}
                                className="basic-multi-select"
                                classNamePrefix="select"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="select-related col-md-10">
                          <div className="row w-100">
                            <label className="label all-text col-2">
                              Related Services
                            </label>
                            <div className="col-9 selector">
                              <RSelect
                                isMulti
                                isDisabled={!isEditClick}
                                value={selectedService}
                                onChange={setSelectedService}
                                options={relatedServices}
                                className="basic-multi-select"
                                classNamePrefix="select"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="select-related col-md-10 ">
                          <div className="row w-100">
                            <label className="label all-text col-2">
                              Related Tools
                            </label>
                            <div className="col-9 selector">
                              <RSelect
                                isMulti
                                isDisabled={!isEditClick}
                                value={selectedTool}
                                onChange={setSelectedTool}
                                options={relatedTools}
                                className="basic-multi-select"
                                classNamePrefix="select"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="grid-row mx-0 d-flex align-items-start">
                        <div className="image-label" style={{ width: "10.8%" }}>
                          Featured Image
                        </div>
                        {values.featured_image !== "" ? (
                          <ImagesGrid
                            name={isEditClick ? "" : "view"}
                            remove={(val, url) => {
                              let resizedUrls = [];

                              setFieldValue("featured_image", "");
                              values.featured_image_resized &&
                                values.featured_image_resized?.length > 0 &&
                                values.featured_image_resized.map((url2) => {
                                  if (url.includes("https")) {
                                    resizedUrls.push(url2);
                                  }
                                  return url2;
                                });
                              setDeletedImagesUrl([
                                ...deletedImagesUrl,
                                url,
                                ...resizedUrls,
                              ]);
                            }}
                            images={[values.featured_image]}
                          />
                        ) : (
                          touched.featured_image &&
                          errors.featured_image && (
                            <div
                              className="english-error"
                              style={{ color: "red" }}
                            >
                              {errors.featured_image}
                            </div>
                          )
                        )}
                      </div>
                      <div className="row mx-0">
                        <div className="mx-auto mt-5 d-flex justify-content-center">
                          {uploadingSingleImage ? (
                            <div className="d-flex justify-content-center align-item-center w-100">
                              <ClipLoader color="#000" loading size={20} />
                            </div>
                          ) : (
                            isEditClick && (
                              <DropzoneElement
                                multiple={false}
                                value="Click to select a file"
                                updateSelectedServiceFiles={(files) =>
                                  handleSingleFilesChange(files, setFieldValue)
                                }
                                type={type.IMAGE}
                              />
                            )
                          )}
                        </div>
                      </div>

                      <div className="grid-row mx-0 d-flex align-items-start">
                        <div
                          className="image-label "
                          style={{ width: "10.8%" }}
                        >
                          Service Images
                        </div>
                        {values.images?.length !== 0 ? (
                          <ImagesGrid
                            name={location.state.name}
                            remove={(val, url) => {
                              setDeletedImagesUrl([...deletedImagesUrl, url]);
                              setFieldValue("images", val);
                            }}
                            images={values.images}
                          />
                        ) : (
                          touched.images &&
                          errors.images && (
                            <div
                              className="english-error"
                              style={{ color: "red" }}
                            >
                              {errors.images}
                            </div>
                          )
                        )}
                      </div>
                      {uploadingImages ? (
                        <div className="d-flex justify-content-center align-item-center w-100">
                          <ClipLoader color="#000" loading size={20} />
                        </div>
                      ) : (
                        <div className="row mx-0">
                          <div className="mx-auto mt-5 d-flex justify-content-center">
                            {isEditClick && (
                              <DropzoneElement
                                value="Click to select files"
                                type={type.IMAGE}
                                updateSelectedServiceFiles={(files) =>
                                  handleFilesChange(
                                    files,
                                    setFieldValue,
                                    values.images
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      )}
                    </fieldset>
                    <div className="row button-row mx-0">
                      <div className="button-col col-8 mx-auto d-flex flex-column">
                        <div className="button-group">
                          {location.state.name === "view" ? (
                            <Fragment>
                              <button
                                className="blue-button"
                                type="button"
                                onClick={() => {
                                  history.push({
                                    pathname: `/vendor/service/${parseInt(
                                      param.id
                                    )}/edit`,
                                    state: {
                                      name: "edit",
                                      id: parseInt(param.id),
                                    },
                                  });
                                }}
                              >
                                Edit
                              </button>
                              <button
                                className="gray-button"
                                type="button"
                                onClick={() => {
                                  history.push("/vendor/service-catalog");
                                }}
                              >
                                Back
                              </button>
                            </Fragment>
                          ) : (
                            <Fragment>
                              {location.state.name === "edit" ? (
                                <Fragment>
                                  <button
                                    key={452984}
                                    className="blue-button"
                                    type="submit"
                                    disabled={loading}
                                  >
                                    {loading ? (
                                      <ClipLoader
                                        color="#000"
                                        loading
                                        size={20}
                                      />
                                    ) : (
                                      "Save Service"
                                    )}
                                  </button>
                                  <button
                                    className="gray-button"
                                    type="button"
                                    onClick={() => {
                                      history.push({
                                        pathname: `/vendor/service/${parseInt(
                                          param.id
                                        )}`,
                                        state: {
                                          name: "view",
                                          id: parseInt(param.id),
                                        },
                                      });
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </Fragment>
                              ) : (
                                <Fragment>
                                  <button
                                    className="blue-button"
                                    type="submit"
                                    key={1098454}
                                    disabled={loading}
                                  >
                                    {loading ? (
                                      <ClipLoader
                                        color="#000"
                                        loading
                                        size={20}
                                      />
                                    ) : (
                                      "Create Service"
                                    )}
                                  </button>
                                  <button
                                    className="gray-button"
                                    type="button"
                                    onClick={() => {
                                      history.push("/vendor/service-catalog");
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </Fragment>
                              )}
                            </Fragment>
                          )}
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    serviceDetails: state.service.serviceDetails,
    categories: state.category.categories,
    load: state.layout.isLoading,
  };
};

const mapDispatchTopProps = {
  set_categories,
  set_service_details,
  set_loading,
};

export default connect(mapStateToProps, mapDispatchTopProps)(Service);
